export default "__VITE_ASSET__Dpm1nfhj__"